import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit,
  Inject,
} from '@angular/core';
import {
  Event,
  NavigationStart,
  Router,
  ActivatedRoute,
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BaseService } from 'src/app/base.service';
import { CommonServiceService } from './../../common-service.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  auth: boolean = false;
  isPatient: boolean = false;
  page;
  headerTop: boolean = false;
  base;
  Provider 
  // = JSON.parse(localStorage.getItem('get_provider'));
   Provider_id
  clickTrack = false;
  bellCollapsed = true;
  userCollapsed = true;
  user = null
  constructor(
    @Inject(DOCUMENT) private document,
    private BaseService :BaseService,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private activeRoute: ActivatedRoute,
    public commonService: CommonServiceService
    ,public translate: TranslateService
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
      var res = event.url.split("/");
      this.base = res[1];
      this.page = res[2];
      console.log(this.base);
      console.log(this.page);
        if ( event.url == '/home-slider-one') {         
          this.headerTop = true;
        } else {
          this.headerTop = false;
        }
      }
    });
    
    if(localStorage.getItem('currentLanguage')){
   this. currentLanguage  = localStorage.getItem('currentLanguage')
    }
    if(localStorage.getItem('get_provider')){
      this.Provider  = JSON.parse(localStorage.getItem('get_provider')) 
      this.Provider_id = this.Provider.id
      console.log('Provider',this.Provider)
       }
      //  if(this.Provider.logo){
      this.logo = this.Provider.logo;
      this.translate.use(this.currentLanguage);
    // }
  }
  MianColoe;
  currentLanguage  
  // Provider  
  logo  
  file_url = this.BaseService.file_url;


  ngOnInit(): void {
    if(localStorage.getItem('user')){
      this.auth = true;
      this.user = JSON.parse(localStorage.getItem('user')).user
      
    }
    if(JSON.parse( localStorage.getItem('MianColoe'))){
      this.MianColoe = JSON.parse( localStorage.getItem('MianColoe'));
    }
    if(localStorage.getItem('get_provider')){
      this.Provider= JSON.parse(localStorage.getItem('get_provider'));
      this.logo  =  this.Provider. logo
    }
  
   console.log('currentLanguage' ,this.currentLanguage)
   console.log('logo' ,this.logo)
   
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  OnclickTrack(){
    this.clickTrack = !this.clickTrack;
    console.log(this.clickTrack)
  }
  
  mapGrid() {
    this.router.navigate(['/map-grid']);
  }

  mapList() {
    this.router.navigate(['/map-list']);
  }

  addStyle() {
    if (document.getElementById('submenu').style.display == 'block') {
      document.getElementById('submenu').style.display = 'none';
    } else {
      document.getElementById('submenu').style.display = 'block';
    }
  }

  doctor(name) {
    this.page = name;
    this.router.navigate(['/doctor/dashboard']);
  }

  logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    this.auth = false;
    // this.isPatient = false;
    this.router.navigate(['/login-page']);
  }

  languang(lang: any){
    if(lang == 'Arabic'){
     localStorage.setItem('currentLanguage' , 'ar')
     window.location.reload();
     return;
    }
    else if(lang == 'English'){
      localStorage.setItem('currentLanguage' , 'en')
      window.location.reload();
      return;
    }
    else if(lang == 'Truuc'){
      localStorage.setItem('currentLanguage' , 'tr')
      window.location.reload();
      return;
    }
  }
  home() {
    this.commonService.nextmessage('main');
    this.router.navigateByUrl('/').then(() => {
      this.router.navigate(['/']);
    });
  }

  navigate(name) {
    // if(localStorage.getItem('get_provider')){
    //   this.Provider  =  localStorage.getItem('get_provider')
      console.log('Provider',this.Provider)
    //    }
    this.page = name;
    console.log(name);
    if (name === 'Admin') {
      this.router.navigate(['/admin']);
      this.commonService.nextmessage('admin');
    } else  if(name === 'dashboard'){
      this.router.navigate(['/dashboard']);
      this.commonService.nextmessage('dashboard');
    }
   else if(name === 'confirm-order'){
      this.router.navigate(['/confirm-order']);
      this.commonService.nextmessage('confirm-order');
    }
    else if (name === 'plcing-order/') {
     
      this.router.navigate([name+this.Provider_id]);
      this.commonService.nextmessage('confirm-order');
    }
  }
  bell() {
    this.bellCollapsed = !this.bellCollapsed;
    if (!this.userCollapsed) {
      this.userCollapsed = true;
    }
  }
}
